import { AlertTriangle } from "lucide-react";

import { BotonReintentar } from "@/components/estados/BotonReintentar";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";
import { getApiErrorMessage } from "@/lib/api";

interface EstadoDeErrorProps {
  titulo: string;
  error: unknown;
  onReintentar: () => void;
  reintentando: boolean;
}

/** Estado de "no se pudo cargar", con el detalle del backend y un reintento. */
export function EstadoDeError({
  titulo,
  error,
  onReintentar,
  reintentando,
}: EstadoDeErrorProps) {
  return (
    <Empty className="rounded-xl border">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <AlertTriangle />
        </EmptyMedia>
        <EmptyTitle>{titulo}</EmptyTitle>
        <EmptyDescription>
          {getApiErrorMessage(error, "Ocurrió un error inesperado. Inténtalo de nuevo.")}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <BotonReintentar onReintentar={onReintentar} reintentando={reintentando} />
      </EmptyContent>
    </Empty>
  );
}
